import { useMutation, useQueryClient } from 'react-query';

import { taskApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';
import { UpdateTaskDto } from 'src/types/task.types';

const useUpdateTask = (assetId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ taskId, data }: { taskId: string; data: UpdateTaskDto }) =>
      taskApi.update(assetId, taskId, data),
    {
      onSuccess: () => {
        trackEvent('Task', 'update');
        queryClient.invalidateQueries(['tasks', assetId]);
        queryClient.invalidateQueries(['my-tasks']);
      },
    }
  );
};

export default useUpdateTask;
